import React from 'react';
import classNames from 'classnames';
import './Title.pcss';

type Props = {
  className?: string;
  text: string;
};

export const Title = ({ text, className }: Props) => {
  return <h1 className={classNames(className, 'common-title')}>{text}</h1>;
};
